import React from "react";
import Form from "./components/Form";

const App = () => {
  return <Form />;
};

export default App;
